import { useMutation, useQuery } from 'react-query';
import { RemoteTermsRepo } from '@repository/terms/TermsRepo';
import { RemoteUserTermsAgreesRepo } from '@repository/userTermsAgrees/UserTermsAgreesRepo';
import TermsDto from '@domain/rs/terms/TermsRs';
import { TERMS, TERMS_TYPE } from '@domain/constant/v1/termsType';

export const keys = ['profile', 'preferential', 'terms'];
export const sensitiveTermsListKeys = [...keys, 'sensitive'];
const remoteTermsRepo = new RemoteTermsRepo();
const remoteUserTermsAgreesRepo = new RemoteUserTermsAgreesRepo();

// 동의 여부 조회
const fetchTermsCheckNew = async (termType: TERMS_TYPE) => {
  const { data } = await remoteUserTermsAgreesRepo.fetchTermsCheckNew(termType);
  return data;
};

//본문 조회
const fetchTermsOne = async (termsSn?: number | null) => {
  if (!termsSn) return undefined;

  const { data } = await remoteTermsRepo.fetchTermsOne(termsSn);
  return data.terms;
};

const fetchSaveProfileSensitiveInfoAgree = async (termsSns: number[]) => {
  const { data } = await remoteUserTermsAgreesRepo.saveProfileSensitiveInfoAgree(termsSns);
  return data;
};

const fetchSensitiveTermsList = async () => {
  const termsList: TermsDto[] = [];

  //민감 정보 수집 및 이용 동의 여부 조회
  const sensitivePrivacyPolicyYn = await fetchTermsCheckNew(TERMS.SENSITIVE_PRIVACY_POLICY);
  if (sensitivePrivacyPolicyYn.existsNewTermsAgree) {
    const sensitivePrivacyPolicyData = await fetchTermsOne(sensitivePrivacyPolicyYn.termsSn);
    if (sensitivePrivacyPolicyData) {
      termsList.push(sensitivePrivacyPolicyData);
    }
  }

  return termsList;
};

//민감정보 관련 약관 리스트 조회
export function useSensitiveTermsList(isEnabled: boolean) {
  return useQuery(sensitiveTermsListKeys, fetchSensitiveTermsList, {
    enabled: isEnabled,
  });
}

//약관 동의 > 저장
export function useSaveProfileSensitiveInfoAgree() {
  return useMutation((termsSns: number[]) => fetchSaveProfileSensitiveInfoAgree(termsSns));
}
